import React, { PureComponent } from 'react';

import { track } from '@utils';

class Tracking extends PureComponent {
  static defaultProps = {
    trigger: ['click'],
    data: {},
    children: '',
  };

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  tracking = () => {
    const { data } = this.props;
    track(data);
  };

  componentDidMount() {
    const { trigger } = this.props;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    trigger.forEach((event) => {
      self.ref.current.addEventListener(event, self.tracking);
    });
  }

  componentWillUnmount() {
    const { trigger } = this.props;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    trigger.forEach((event) => {
      self.ref.current.removeEventListener(event, self.tracking);
    });
  }

  render() {
    const { children } = this.props;
    return <div ref={this.ref}>{children}</div>;
  }
}
export default Tracking;
